module.exports = __webpack_public_path__ + "static/media/ms.83137d65.svg";